module.exports = __webpack_public_path__ + "img/zimg4.61ced74b.png";